import React, { useMemo, useRef, useState } from "react";
import { projects } from "../data/portfolio";
import P5Backdrop from "../components/P5Backdrop";
import ProjectCard from "../components/ProjectCard";
import { PageMeta } from "../components/SiteChrome";

const filters = [
  "Everything",
  "Strategy",
  "AI",
  "Applications",
  "UX & UI",
  "Photography",
  "Video",
  "Sound",
];

export default function WorkPage() {
  const [activeFilter, setActiveFilter] = useState("Everything");
  const filterBarRef = useRef(null);
  const workGridRef = useRef(null);
  const visibleProjects = useMemo(
    () =>
      activeFilter === "Everything"
        ? projects
        : projects.filter((project) =>
            project.categories.includes(activeFilter)
          ),
    [activeFilter]
  );

  const selectFilter = (filter) => {
    setActiveFilter(filter);

    window.requestAnimationFrame(() => {
      const headerHeight =
        document.querySelector(".site-header")?.getBoundingClientRect().height ||
        0;
      const filterHeight =
        filterBarRef.current?.getBoundingClientRect().height || 0;
      const gridRect = workGridRef.current?.getBoundingClientRect();

      if (!gridRect) return;

      const gridTop = gridRect.top + window.scrollY;

      const prefersReducedMotion =
        window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ||
        false;

      window.scrollTo({
        top: Math.max(0, gridTop - headerHeight - filterHeight - 16),
        behavior: prefersReducedMotion ? "auto" : "smooth",
      });
    });
  };

  return (
    <>
      <PageMeta
        title="Work"
        description="Selected digital strategy, service design, AI, software, photography, video and sound projects by Clément Girault."
      />
      <section className="page-hero work-hero">
        <P5Backdrop variant="field" palette="cream" />
        <span className="eyebrow">Selected archive · 01—12</span>
        <h1>Work without<br />hard borders.</h1>
        <p>
          Digital platforms, experimental software, machine intelligence,
          photography, moving image and sound.
        </p>
      </section>
      <section className="work-index section-pad">
        <div
          className="filter-bar"
          aria-label="Filter projects"
          ref={filterBarRef}
        >
          {filters.map((filter) => (
            <button
              type="button"
              className={activeFilter === filter ? "is-active" : ""}
              aria-pressed={activeFilter === filter}
              onClick={() => selectFilter(filter)}
              key={filter}
            >
              {filter}
            </button>
          ))}
        </div>
        <div className="work-grid" aria-live="polite" ref={workGridRef}>
          {visibleProjects.map((project) => (
            <ProjectCard project={project} key={project.slug} />
          ))}
        </div>
      </section>
    </>
  );
}
